import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import IPaginatedesponse from '@models/paginated-reponse';
import CandidateItem from '@candidates/models/dto/get-candidates.dto';
import GetOneCandidateDto from '@candidates/models/dto/get-one-candidate.dto';

export const getCandidates = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<CandidateItem>>> => {
  return await axiosClient.post(
    EndPoints.candidates.getCandidates(paginatedParams),
    searchCriteria,
  );
};

export const getCandidateById = async (
  id: string,
): Promise<AxiosResponse<GetOneCandidateDto>> => {
  return await axiosClient.get(EndPoints.candidates.getCandidateById(id));
};
export const disableCandidateById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.candidates.disableCandidateById(id));
};

export const enableCandidateById = async (
  id: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.put(EndPoints.candidates.enableCandidateById(id));
};
